<template>
    <van-popup v-model:show="show" position="right" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }">
        <div class="popupContainer">
            <CustomHeader :text="$t('common.history')" :isPopupCloseBackIcon="true" @closePopup="close" bg-color="#101423"/>
            <div class="historyContainer" v-if="!isUseFirstRecharge">
                <NoData v-if="historyList.length <= 0" />
                <CashBackHistoryCard v-for="(item, index) in historyList" :key="index" :isShowDetails="false"
                    :createTime="item.lossDate ?? item.createTime" :day-count="item.dayCount ?? item.day" :title="title"
                    :activity-status="item.status" :given-amount="item.givenAmount ?? item.claimGiftAmount"
                    :total-amount="item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss"
                    :available-amount="item.remainGiftAmount ?? item.availableAmount"
                    :day-list="convertStringToArray(item.dayRewards)" :isShowTodayHighlight="false" />
                <van-row v-if="isShowMore">
                    <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                            @click="getNextPageRewardData"></van-col>
                </van-row>
            </div>
        </div>

    </van-popup>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, PropType, computed } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import CashBackHistoryCard from './cashbackHistoryCard.vue';
import { convertStringToArray } from '@/utils/commonFunction';
import CustomHeader from '../../components/common/customHeader.vue';
import NoData from '../../components/common/noData.vue';

const props = defineProps({
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    title: String,
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
})
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const isShowMore = computed(() => props.showIcon)
const historyList = computed(() => props.list)

const loadingRef = ref()
const emits = defineEmits(["getHistoryList", 'updateHistoryList', 'resetHistoryData'])

const open = () => {
    show.value = true
    emits('getHistoryList')
}

const close = () => {
    show.value = false
    emits('resetHistoryData')
}

const getNextPageRewardData = () => {
    emits('updateHistoryList')
}

defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-color: rgb(9, 15, 31);
}

.historyContainer {
    padding: 60px 25px;
    height: calc(100vh - 50px);
    overflow-y: auto;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.historyContainer::-webkit-scrollbar {
    display: none;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
    padding: 10px;
}
</style>